import React from "react";
import { FaTimes } from "react-icons/fa";
import { formatToman } from "../../utils/referralHelpers";

export default function WithdrawalModal({
  form,
  setForm,
  onClose,
  onSubmit,
  submitting,
  availableBalance,
  minimumWithdrawalAmount,
}) {
  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-4">
      <div className="w-full max-w-md rounded-[2rem] border border-white/10 bg-[#10182A] p-5 shadow-2xl">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-black text-white">
            درخواست برداشت
          </h2>

          <button
            type="button"
            onClick={onClose}
            className="w-10 h-10 rounded-xl bg-white/5 hover:bg-white/10 flex items-center justify-center text-white"
          >
            <FaTimes />
          </button>
        </div>

        <p className="mt-3 text-sm leading-7 text-slate-400">
          موجودی قابل برداشت: {formatToman(availableBalance)}
          <br />
          حداقل برداشت: {formatToman(minimumWithdrawalAmount)}
        </p>

        <form onSubmit={onSubmit} className="mt-5 space-y-4">
          <Input
            label="مبلغ"
            type="number"
            value={form.amount}
            onChange={(v) =>
              setForm((p) => ({
                ...p,
                amount: v,
              }))
            }
            placeholder="مثلاً 500000"
          />

          <Input
            label="شماره شبا"
            value={form.iban}
            onChange={(v) =>
              setForm((p) => ({
                ...p,
                iban: v,
              }))
            }
            placeholder="IRxxxxxxxxxxxxxxxxxxxxxxxx"
          />

          <Input
            label="نام صاحب حساب"
            value={form.accountOwnerName}
            onChange={(v) =>
              setForm((p) => ({
                ...p,
                accountOwnerName: v,
              }))
            }
            placeholder="مثلاً مجتبی رمضانی‌نیا"
          />

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-4 rounded-2xl bg-gradient-to-l from-green-500 to-emerald-500 text-white font-black disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {submitting ? "در حال ثبت..." : "ثبت درخواست برداشت"}
          </button>
        </form>
      </div>
    </div>
  );
}

function Input({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
}) {
  return (
    <label className="block">
      <span className="text-sm text-slate-300">
        {label}
      </span>

      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="mt-2 w-full rounded-2xl bg-white/5 border border-white/10 px-4 py-3 outline-none focus:border-purple-500 text-white placeholder:text-slate-600"
      />
    </label>
  );
}